
<template>
  <div class="d-block text-justify">
  </div>
</template>
<script>
import { getFintoc } from '@fintoc/fintoc-js';

export default {
  name: "widgetFintoc",
  components: {
  },
  props: {
    project_id: {
      type: Number,
      required: true
    }
  },
  data(){
    return {
      loading: true,
      widget_fintoc: null,
    }
  },
  mounted() {
    this.axios.post("payments/fintoc", {contract_id: this.contract_id, project_id: this.project_id}).then(result => {
      this.widget_method(result.data.widget_token, result.data.public_key)
    }).catch(error => {
      console.log(error)
      this.destroy_widget()
    })
  },
  computed: {
    contract_id(){
				return this.$store.getters.getContractId == undefined ? null : this.$store.getters.getContractId
			},
  },
  methods: {
    async widget_method( widgetToken, public_key ) {
      let options = {
        holderType: 'individual',
        widgetToken: widgetToken,
        product: 'subscriptions',
        publicKey: public_key,
        onExit: () => { this.destroy_widget() },
        onSuccess: (data) => { this.succes_pac(data)}
      }
      const Fintoc = await getFintoc();
      this.widget = Fintoc.create(options);
      this.widget.open();
    },
    destroy_widget() {
      this.$emit('showWidget', false);
    },
    succes_pac(data){
      this.$swal('Éxito', 'El PAC fue agregado con éxito, este proceso puede tardar entre 24 a 48 Hrs. en validarse, cuando sea aceptado por tu banco te enviaremos un correo.', 'success');
      this.$store.commit("setAutomatedPayments", true);
      this.axios.post("payments/fintoc_pending", {fintoc: data}).then(result => {
        this.$emit('dataResultWidget', result);
      }).catch(error => {
        console.log(error)
       this.destroy_widget()
      })
    }
  }
}
</script>r
